import { contactRoutes } from '../../../../routes';
import UnreadMessageChannelIcon from '../UnreadMessageChannelIcon/UnreadMessageChannelIcon';
//import DisplayHTML from '../../../components/DisplayHTML/DisplayHTML';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { InboxItem } from '../../../../sic-lib/types/InboxTypes';
import NavLinkListItem from '../../../Navigation/NavLinkListItem/NavLinkListItem';
import DisplayPhoneNumber from '../../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';

const useStyles = makeStyles()((theme: Theme) => ({
    /* Important for height to be inforced because is a virtual list */
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        minHeight: '72px',
        listStyle: 'none',
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
    },
    primaryText: {
        color: theme.palette.text.primary,
    },
    checkbox: {
        paddingRight: theme.spacing(2),
    },
    action: {
        width: '72px',
        right: 0,
    },
}));

interface Props {
    config: InboxItem;
}

export default function UnreadMessagesListItem({ config }: Props) {
    const { classes } = useStyles();
    const contactPath = contactRoutes.setDetails(config.contactId);

    return (
        <NavLinkListItem pathname={contactPath} ContainerComponent="div" className={classes.root}>
            <ListItemIcon className={classes.checkbox}>
                <Badge
                    badgeContent={config.unreadCount}
                    overlap="circular"
                    color="secondary"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                >
                    <Avatar variant="rounded">
                        {config.firstName ? config.firstName.slice(0, 1) : 'X'}
                    </Avatar>
                </Badge>
            </ListItemIcon>
            <ListItemText
                primary={`${config.firstName} ${config.lastName}`}
                primaryTypographyProps={{
                    noWrap: true,
                    className: classes.primaryText,
                }}
                secondary={<DisplayPhoneNumber phoneNumber={config.text} />}
                secondaryTypographyProps={{
                    noWrap: true,
                }}
            />
            <ListItemSecondaryAction className={classes.action}>
                <UnreadMessageChannelIcon
                    channelType={config.subType}
                    direction={config.direction}
                    lastMessage={config.lastDate}
                />
            </ListItemSecondaryAction>
        </NavLinkListItem>
    );
}
